import React from "react";
import AddMiniGame3Modal from "../../views/superAdmin-all/questionnaire-modals/AddMiniGame3Modal";
import AddMiniGame4Modal from "../../views/superAdmin-all/questionnaire-modals/AddMiniGame4Modal";
import AddMiniGame5Modal from "../../views/superAdmin-all/questionnaire-modals/AddMiniGame5Modal";
import AddMiniGame6Modal from "../../views/superAdmin-all/questionnaire-modals/AddMiniGame6Modal";
import AddMiniGame7Modal from "../../views/superAdmin-all/questionnaire-modals/AddMiniGame7Modal";
import AddMiniGame8Modal from "../../views/superAdmin-all/questionnaire-modals/AddMiniGame8Modal";
import AddMiniGame9Modal from "../../views/superAdmin-all/questionnaire-modals/AddMiniGame9Modal";
import AddMiniGame10Modal from "../../views/superAdmin-all/questionnaire-modals/AddMiniGame10Modal";

export default function QuestionnaireModalRenderer({
  selectedMiniGame,
  isModalOpen,
  toggleModal,
  handleQuestionAdded,
}) {
  switch (selectedMiniGame) {
    case "3":
      return (
        <AddMiniGame3Modal
          isOpen={isModalOpen}
          toggle={toggleModal}
          onQuestionAdded={handleQuestionAdded}
        />
      );
    case "4":
      return (
        <AddMiniGame4Modal
          isOpen={isModalOpen}
          toggle={toggleModal}
          onQuestionAdded={handleQuestionAdded}
        />
      );
    case "5":
      return (
        <AddMiniGame5Modal
          isOpen={isModalOpen}
          toggle={toggleModal}
          onQuestionAdded={handleQuestionAdded}
        />
      );
    case "6":
      return (
        <AddMiniGame6Modal
          isOpen={isModalOpen}
          toggle={toggleModal}
          onQuestionAdded={handleQuestionAdded}
        />
      );
    case "7":
      return (
        <AddMiniGame7Modal
          isOpen={isModalOpen}
          toggle={toggleModal}
          onQuestionAdded={handleQuestionAdded}
        />
      );
    case "8":
      return (
        <AddMiniGame8Modal
          isOpen={isModalOpen}
          toggle={toggleModal}
          onQuestionAdded={handleQuestionAdded}
        />
      );
    case "9":
      return (
        <AddMiniGame9Modal
          isOpen={isModalOpen}
          toggle={toggleModal}
          onQuestionAdded={handleQuestionAdded}
        />
      );
    case "10":
      return (
        <AddMiniGame10Modal
          isOpen={isModalOpen}
          toggle={toggleModal}
          onQuestionAdded={handleQuestionAdded}
        />
      );
    default:
      return null;
  }
}
